import { Box, Flex, Heading, Text } from "@radix-ui/themes";
import { BaseConsultForm } from "~/components/BaseConsultForm";
import {
  Locale,
  type LocalizedStrings,
  useLocalization,
} from "~/components/localization/LocalizationProvider";
import styles from "./kids-club.module.css";

type Localization = {
  title: string;
  firstParagraph: string;
  secondParagraph: string;
  guardianPlaceholder: string;
  patientPlaceholder: string;
  emailPlaceholder: string;
  phonePlaceholder: string;
  submit: string;
};

const englishLocalization: Localization = {
  title: "Welcome to the Kids Club!",
  firstParagraph:
    "Dr. Garcia-Paul and her team are happy to introduce the MOS Kids Club! It’s a free program with exciting benefits that supports you and your child with early orthodontic intervention.",
  secondParagraph:
    "Whether you know your child is ready for orthodontic treatment or you just want a check-up to see how things are going, our Kids Club is designed to give parents the peace of mind that you are addressing your child’s individual needs at the time that’s best for them!",
  guardianPlaceholder: "Parent/Legal Guardian",
  patientPlaceholder: "Patient",
  emailPlaceholder: "Email",
  phonePlaceholder: "Phone",
  submit: "Transform my smile",
};

const spanishLocalization: Localization = {
  title: "¡Bienvenido al Kids Club!",
  firstParagraph:
    "La Dra. Garcia-Paul y su equipo están felices de presentar el MOS Kids Club. Es un programa gratuito con beneficios emocionantes que los apoya a usted y a su hijo con intervención ortodóncica temprana.",
  secondParagraph:
    "Ya sea que sepa que su hijo está listo para el tratamiento de ortodoncia o solo quiera una revisión para ver cómo va todo, nuestro Kids Club está diseñado para darle tranquilidad mientras atiende las necesidades individuales de su hijo en el momento más adecuado.",
  guardianPlaceholder: "Nombre completo del padre o tutor legal",
  patientPlaceholder: "Nombre completo del paciente",
  emailPlaceholder: "Correo electrónico",
  phonePlaceholder: "Teléfono",
  submit: "Transforma mi sonrisa",
};

const localized: LocalizedStrings<Localization> = {
  [Locale.EN]: englishLocalization,
  [Locale.ES]: spanishLocalization,
};

export function KidsClubPage() {
  const getLocalization = useLocalization(localized);

  return (
    <div className={styles.page}>
      <Flex className={styles.layout} align="stretch">
        <Box className={styles.contentColumn}>
          <Box className={styles.contentInner}>
            <Heading as="h1" className={styles.heading}>
              {getLocalization("title")}
            </Heading>
            <Flex direction="column" gap="5" className={styles.copy}>
              <Text as="p">{getLocalization("firstParagraph")}</Text>
              <Text as="p">{getLocalization("secondParagraph")}</Text>
            </Flex>
            <BaseConsultForm source="kids-club" />
          </Box>
        </Box>
        <Box
          className={styles.imageColumn}
          aria-label="Smiling children in the Miami Orthodontic Specialists Kids Club"
        />
      </Flex>
    </div>
  );
}
